var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Image, DecorativeImage, LazyImage, DecorativeLazyImage, } from '../image';
import { getCommonProps } from '../helpers/common-props';
const isSourceElement = (child) => {
    return child.type === 'source';
};
const isImageComponent = (child) => {
    return child.type === Image;
};
const isDecorativeImageComponent = (child) => {
    return child.type === DecorativeImage;
};
export const LazyPicture = React.forwardRef((props, ref) => {
    const { children } = props, rest = __rest(props, ["children"]);
    const commonProps = getCommonProps(props);
    const newChildren = children.map((child) => {
        if (isSourceElement(child)) {
            return (React.createElement("source", Object.assign({}, child.props, { key: child.key, contentEditable: undefined, srcSet: undefined, "data-srcset": child.props.srcSet })));
        }
        if (isImageComponent(child)) {
            return (React.createElement(LazyImage, Object.assign({}, child.props, { key: child.key, src: undefined, srcSet: undefined, "data-src": child.props.src, "data-srcset": child.props.srcSet, _disableNoScript: true })));
        }
        if (isDecorativeImageComponent(child)) {
            return (React.createElement(DecorativeLazyImage, Object.assign({}, child.props, { key: child.key, src: undefined, srcSet: undefined, "data-src": child.props.src, "data-srcset": child.props.srcSet, _disableNoScript: true })));
        }
        return undefined;
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("noscript", null,
            React.createElement("picture", null, children)),
        React.createElement("picture", Object.assign({ ref: ref }, commonProps, rest), newChildren)));
});
LazyPicture.displayName = 'Picture';
